import styled from 'styled-components';

import { fonts } from 'ui/theme';

export const PageContainer = styled.div`
  font-family: ${fonts.sansSerif};
`;
